import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {CustomComponent} from '../components';
import emitter from '../util/emitter';

import './ProgressBar.scss';


export class ProgressBar extends CustomComponent {
    started: boolean;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.started = false;
        this.state = {
            ...this.state,
            hide: true,
            progress: 0,
            duration: 2000,
        };
    }

    componentDidMount() {
        emitter.on('start-progress-bar', this.startProgress);
        emitter.on('finish-progress-bar', this.finishProgress);
    }

    componentWillUnmount() {
        emitter.off('start-progress-bar', this.startProgress);
        emitter.off('finish-progress-bar', this.finishProgress);
    }

    @autobind
    startProgress() {
        this.started = true;
        this.setState({
            hide: false,
            progress: 95,
            duration: 2000,
        });
    }

    @autobind
    finishProgress() {
        if (this.started) {
            this.started = false;
            this.setState({
                hide: false,
                progress: 100,
                duration: 300,
            });
            setTimeout(() => {
                this.setState({
                    hide: true,
                    progress: 0,
                });
            }, 400);
        }
    }

    render() {
        const {progress, hide, duration} = this.state;
        return (
            <div className="ProgressBar" style={{
                height: hide ? '0' : '3px',
                right: `${100 - progress}vw`,
                transition: `right ${duration / 1000}s linear`,
            }} />
        );
    }
}
